import axios from 'axios';
import { apiUrl } from './client';

// Pre-login endpoints. These run before a token exists, so the global
// Authorization interceptor simply finds nothing to attach.

/** SignIn — returns the full response body ({ user, token, ... }). */
export const signIn = async (email: string, password: string): Promise<any> => {
  // client marker: the API audits admin-panel sign-ins (success + failed
  // attempts) under Admin: rows; iPad logins send no marker and are not logged.
  const res = await axios.post(apiUrl('SignIn'), { email, password, client: 'admin-panel' });
  return res.data;
};

/** Request a reset link. Fire-and-forget on the caller side (no user enumeration). */
export const requestPasswordReset = async (email: string): Promise<void> => {
  await axios.post(apiUrl('ForgotPassword'), { email });
};

/** Consume a single-use reset token. Returns { message } on success. */
export const resetPassword = async (token: string, password: string): Promise<any> => {
  const res = await axios.post(apiUrl('ForgotPassword/reset'), { token, password });
  return res.data;
};

/** N-07: self-service password change (clears mustChangePassword server-side).
 *  Authenticates by email + current password — no token needed, so it works
 *  from the pre-login forced-change screen. */
export const changePassword = async (email: string, currentPassword: string, newPassword: string): Promise<any> => {
  const res = await axios.post(apiUrl('SignIn/change-password'), { email, currentPassword, newPassword });
  return res.data;
};
